import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";
import { BrowserRouter } from "react-router-dom";

import { Provider } from "react-redux";
import store from "store/configureStore";
import App from "./App";
import { AUTH_LOG_IN_USER } from "actions/types";
import { AUTH_LOG_IN_PROVIDER } from "containers/auth/Pet_Services_Portal/actions";
import { getStripePromise } from "userScript/userScript";
import "./index.sass";

// Auth state setup
const token = localStorage.getItem("token");
const tokenProvider = localStorage.getItem("tokenProvider");

if (token) {
  store.dispatch({ type: AUTH_LOG_IN_USER });
}

if (tokenProvider) {
  store.dispatch({ type: AUTH_LOG_IN_PROVIDER });
}

// Check for client version updates on tab visibility change
document.addEventListener("visibilitychange", () => {
  if (document.visibilityState === "visible") {
    handleClientVersionCheck();
  }
});

async function handleClientVersionCheck() {
  try {
    const currentVersion = localStorage.getItem("currentVersion");
    const res = await axios.get("/api/client_settings/client_version_check", {
      params: { currentVersion },
    });

    if (res.data.clientUpdate) {
      localStorage.setItem("currentVersion", res.data.clientVersion);
      if (typeof caches !== "undefined") {
        const cacheNames = await caches.keys();
        for (const name of cacheNames) {
          await caches.delete(name);
        }      }
      window.location.reload(); // true is no longer needed
    }
  } catch (error) {
    console.error("Version check error:", error);
  }
}

// Render app
const root = ReactDOM.createRoot(document.getElementById("root"));
getStripePromise().then((stripePromise) => {
  root.render(
    <Provider store={store}>
      <BrowserRouter>
        <App stripePromise={stripePromise} />
      </BrowserRouter>
    </Provider>
  );
});
